<template lang="pug">
transition(name="bounce", mode="out-in")
    v-btn(
        v-bind="$attrs",
        v-on="$listeners",
        outlined,
        :color="selected.color || 'textColor'",
        :min-width="buttonWidth",
        large,
        :key="selected.name",
        :block="isXsScreen"
    )
        v-icon(
            left,
            :color="selected.color || 'textColor'",
            :size="selected.size"
        ) {{ selected.icon }}

        span(:style="labelStyles") {{ selected.label }}
        v-icon(right, :class="{ rotate: isActive }") {{ chevronIcon }}
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import { mdiChevronDown } from "@mdi/js"
import THEME from "../../constants/theme"

export default Vue.extend({
  name: "ComboActivatorButton",
  props: {
    selected: { type: Object as PropType<object>, required: true },
    isActive: { type: Boolean, required: true },
  },
  data() {
    return {
      chevronIcon: mdiChevronDown,
      labelStyles: THEME.typography.button,
    }
  },
  computed: {
    buttonWidth(): string {
      return this.isXsScreen ? "100%" : "220px"
    },
    isXsScreen(): boolean {
      return this.$vuetify.breakpoint.name === "xs"
    },
  },
})
</script>

<style lang="sass" scoped>
.rotate
    transform: rotateZ(180deg)
    transition: transform 0.4s ease-in-out
.bounce-enter-active
    transition: opacity .2s, transform .2s ease-in-out
    transform: scale(0.9)
.bounce-leave-active
    transition: opacity .2s
.bounce-enter
    opacity: 0
    transform: scale(1.1)
.bounce-leave-to
    opacity: 0
</style>
